
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function parseJSON(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Money formatter – 1:1 copy of working logic from VariantPicker
  function formatMoney(cents, format = '${{amount}}') {
    if (typeof cents == 'string') {
      cents = ~~(cents).replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      const sNumber = (number / 100.0).toFixed(precision);
      const parts = sNumber.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }

    const match = formatString.match(placeholderRegex);
    if (match) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    }

    return formatString.replace(placeholderRegex, value);
  }

  const productData = parseJSON('product-options-variant-data');
  const fabricData = parseJSON('CylindoFabricData');
  if (!productData || !productData.product) return;

  const tabsRoot = document.getElementById('FabricTabs');
  if (!tabsRoot) return;

  const IS_SALE_FULL_PRICE = tabsRoot.dataset.tabMode === 'sale-full-price';
  const TAB_KEYS = IS_SALE_FULL_PRICE ? ['fullprice', 'sale'] : ['instock', 'mto', 'sale'];

  // ===== Custom scrollbar for fabric tab panels
  function wrapFabricPanels() {
    $$('.fabric-tabs__panel', tabsRoot).forEach((panel) => {
      if (panel.closest('.fabric-tabs__panel-wrap')) return;

      const wrap = document.createElement('div');
      wrap.className = 'fabric-tabs__panel-wrap';
      panel.parentNode.insertBefore(wrap, panel);
      wrap.appendChild(panel);

      const track = document.createElement('div');
      track.className = 'fabric-tabs__scrollbar';
      track.setAttribute('aria-hidden', 'true');

      const thumb = document.createElement('div');
      thumb.className = 'fabric-tabs__scrollbar-thumb';
      track.appendChild(thumb);
      wrap.appendChild(track);

      bindFabricPanelScrollbar(panel, wrap, track, thumb);
    });
    syncFabricPanelWrapState();
  }

  function syncFabricPanelWrapState() {
    $$('.fabric-tabs__panel-wrap', tabsRoot).forEach((wrap) => {
      const panel = wrap.querySelector('.fabric-tabs__panel');
      wrap.classList.toggle('is-active', !!panel?.classList.contains('is-active'));
    });
  }

  function bindFabricPanelScrollbar(panel, wrap, track, thumb) {
    if (panel.__fabricScrollbarBound) return;
    panel.__fabricScrollbarBound = true;

    const update = () => {
      if (!panel.classList.contains('is-active')) return;

      const scrollHeight = panel.scrollHeight;
      const clientHeight = panel.clientHeight;
      const scrollable = scrollHeight > clientHeight + 1;

      track.classList.toggle('is-visible', scrollable);
      wrap.classList.toggle('has-scrollbar', scrollable);
      if (!scrollable) return;

      const trackHeight = track.clientHeight;
      const thumbHeight = Math.max(28, (clientHeight / scrollHeight) * trackHeight);
      const maxScroll = scrollHeight - clientHeight;
      const maxThumbTop = Math.max(0, trackHeight - thumbHeight);
      const thumbTop = maxScroll > 0 ? (panel.scrollTop / maxScroll) * maxThumbTop : 0;

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${thumbTop}px)`;
    };

    panel.__fabricScrollbarUpdate = update;

    panel.addEventListener('scroll', update, { passive: true });

    const onDragStart = (e) => {
      if (!track.classList.contains('is-visible')) return;
      const startY = e.touches ? e.touches[0].clientY : e.clientY;
      const startThumbTop = thumb.getBoundingClientRect().top - track.getBoundingClientRect().top;
      tabsRoot.__fabricScrollbarDrag = {
        panel,
        track,
        thumb,
        startY,
        startThumbTop,
      };
      if (e.cancelable) e.preventDefault();
    };

    thumb.addEventListener('mousedown', onDragStart);
    thumb.addEventListener('touchstart', onDragStart, { passive: false });

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => update());
      ro.observe(panel);
    }
  }

  if (!tabsRoot.__fabricScrollbarDocBound) {
    tabsRoot.__fabricScrollbarDocBound = true;

    const onDragMove = (e) => {
      const drag = tabsRoot.__fabricScrollbarDrag;
      if (!drag) return;
      const y = e.touches ? e.touches[0].clientY : e.clientY;
      const { panel, track, thumb, startY, startThumbTop } = drag;
      const trackHeight = track.clientHeight;
      const thumbHeight = thumb.offsetHeight;
      const maxThumbTop = Math.max(0, trackHeight - thumbHeight);
      const maxScroll = panel.scrollHeight - panel.clientHeight;
      const newThumbTop = Math.min(maxThumbTop, Math.max(0, startThumbTop + (y - startY)));
      panel.scrollTop = maxThumbTop > 0 ? (newThumbTop / maxThumbTop) * maxScroll : 0;
      if (e.cancelable) e.preventDefault();
    };

    const onDragEnd = () => { tabsRoot.__fabricScrollbarDrag = null; };

    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('touchmove', onDragMove, { passive: false });
    document.addEventListener('mouseup', onDragEnd);
    document.addEventListener('touchend', onDragEnd);
  }

  function fitFabricTileLabels(root) {
    if (!root) return;
    root.querySelectorAll('.cylindoVariant__option-color, .cylindoVariant__option-fabric').forEach((el) => {
      if (!el.textContent || !el.textContent.trim()) return;
      el.style.fontSize = '';
      const start = parseFloat(getComputedStyle(el).fontSize);
      if (!start || el.clientWidth < 8) return;
      let size = start;
      let guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && size > 8 && guard < 16) {
        size = Math.round((size - 0.5) * 10) / 10;
        el.style.fontSize = size + 'px';
        guard += 1;
      }
    });
  }

  function refreshFabricScrollbars() {
    syncFabricPanelWrapState();
    $$('.fabric-tabs__panel', tabsRoot).forEach((panel) => {
      panel.__fabricScrollbarUpdate?.();
    });
    fitFabricTileLabels(tabsRoot);
    $$('.fabric-tabs__panel', tabsRoot).forEach((panel) => {
      panel.__fabricScrollbarUpdate?.();
    });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshFabricScrollbars, 100);
  });

  wrapFabricPanels();
  syncFabricPanelWrapState();

  // ----- Render hover cards from fabric data -----
  function renderFabricHoverCards() {
    if (!fabricData || !fabricData.fabrics || !Array.isArray(fabricData.fabrics)) return;
    
    // Find all hover card containers (desktop and mobile)
    const hoverContainers = document.querySelectorAll('[cylindo-fabric-hover-cards]');
    if (hoverContainers.length === 0) return;
    
    hoverContainers.forEach(container => {
      const isMobile = container.getAttribute('cylindo-fabric-mobile') === 'true';
      
      // Clear existing content
      container.innerHTML = '';
      
      // Render each fabric card
      fabricData.fabrics.forEach(fabric => {
        const value = fabric.fabric;
        const colorSplit = value.split(' / ');
        const fabricWithDescription = colorSplit[0];
        const color = colorSplit[1] || '';
        
        const { careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly, image } = fabric;
        
        // Create hover card element
        const hoverCard = document.createElement('div');
        hoverCard.className = 'cylindoVariant__hover';
        hoverCard.setAttribute('data-value', value);
        
        // Build image URL with responsive sizes
        const imageDataSrc = image.url.replace('width=100', 'width={width}').replace('height=100', 'height={height}');
        
        if (isMobile) {
          // Mobile: Create modal structure directly inside container (like TypeScript version)
          const modal = document.createElement('div');
          modal.className = 'popupModal';
          // Modal ID should match exactly with toggle-modal attribute (no CSS.escape for ID)
          modal.id = `modal-${value}`;
          // Initially hidden (will be shown when opened)
          modal.style.display = 'none';
          modal.innerHTML = `
            <div class="popupModal__mask"></div>
            <div class="popupModal__box">
              <div class="popupModal__header">
                <button class="popupModal__close" aria-label="Close modal">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" focusable="false">
                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M10.714 1.286l-9.428 9.428M1.286 1.286l9.428 9.428" stroke-width=".85714"/>
                    </g>
                  </svg>
                </button>
              </div>
              <div class="popupModal__content" role="dialog" aria-modal="true">
                <div class="cylindoVariant__hover" data-value="${value}">
                  ${createDesktopCardHTML(fabricWithDescription, color, image, imageDataSrc, careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly)}
                </div>
              </div>
            </div>
          `;
          // Append modal directly to container (not body)
          container.appendChild(modal);
        } else {
          // Desktop: Just the card content
          hoverCard.innerHTML = createDesktopCardHTML(fabricWithDescription, color, image, imageDataSrc, careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly);
          container.appendChild(hoverCard);
        }
      });
    });
  }

  // Set hover fabric prices – 1:1 clone of VariantSelect.updateHoverCards logic
  function updateHoverCardPrices() {
    if (!productData || !productData.variants || !productData.options) return;

    const fabricIdx = productData.options.indexOf('Fabric');
    if (fabricIdx === -1) return;

    // Build current options array in the same order as productData.options
    const selection = getCurrentSelection();
    const baseOptions = productData.options.map((name) => selection[name] || null);

    const hoverCards = document.querySelectorAll('[cylindo-fabric-hover-cards] .cylindoVariant__hover');
    if (!hoverCards.length) return;

    hoverCards.forEach((card) => {
      const priceEl = card.querySelector('[cylindo-fabric-price]');
      const fabric = card.getAttribute('data-value');
      if (!priceEl || !fabric) return;

      const options = baseOptions.slice();
      options[fabricIdx] = fabric;

      const variant = productData.variants.find((v) => {
        return Array.isArray(v.options) && v.options.every((opt, i) => options[i] === opt);
      });

      if (variant && typeof variant.price !== 'undefined') {
        priceEl.textContent = formatMoney(variant.price);
      }
    });
  }

  // Helper function to create desktop card HTML
  function createDesktopCardHTML(fabricWithDescription, color, image, imageDataSrc, careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly) {
    return `
      <div class="cylindoVariant__hover-header">
        <div class="cylindoVariant__hover-img">
          <img 
            src="${image.url}"
            class="inlineImg lazyautosizes lazyload"
            style="--focal-x: 50%; --focal-y: 50%;"
            data-src="${imageDataSrc}"
            data-widths="[540, 720, 900, 1080, 1250, 1440, 1680, 1920]"
            data-aspectratio="${image.aspectRatio}"
            data-sizes="auto"
            alt="${image.alt || ''}" 
          />
        </div>
        <div class="cylindoVariant__hover-fabric">
          <p class="cylindoVariant__hover-fabricGroup">${fabricWithDescription}</p>
          <h6 class="cylindoVariant__hover-fabricTitle">${color}</h6>
          <p cylindo-fabric-price></p>
        </div>
      </div>
      <div class="cylindoVariant__hover-content">
        <hr />
        <ul class="cylindoVariant__hover-details">
          <li>
            <span class="cylindoVariant__hover-detailsLabel">Material</span>
            <span class="cylindoVariant__hover-detailsValue">${material || ''}</span>
          </li>
          <li>
            <span class="cylindoVariant__hover-detailsLabel">Care Instructions</span>
            <span class="cylindoVariant__hover-detailsValue">${careInstructions || ''}</span>
          </li>
          <li>
            <span class="cylindoVariant__hover-detailsLabel">Pet/Kid Friendly</span>
            <span class="cylindoVariant__hover-detailsValue">${petKidFriendly || ''}</span>
          </li>
        </ul>
        <hr />
        <div class="cylindoVariant__hover-valueprop">
          <p class="cylindoVariant__hover-valuepropLabel">${descriptionLabel || ''}</p>
          <p class="cylindoVariant__hover-valuepropContent">${descriptionContent || ''}</p>
        </div>
      </div>
    `;
  }

  // ----- Modal handling for mobile View Details buttons (matching TypeScript ModalManager) -----
  function initModalHandling() {
    let currentModal = null;
    
    // Handle View Details button clicks
    document.addEventListener('click', (e) => {
      const toggleBtn = /** @type {HTMLElement | null} */ (e.target?.closest?.('[toggle-modal]'));
      if (!toggleBtn) return;
      
      const modalId = toggleBtn.getAttribute('toggle-modal');
      if (!modalId) return;
      
      // Use querySelector with attribute selector to handle IDs with special characters
      const modal = document.querySelector(`[id="${modalId}"]`);
      if (!modal) return;
      
      // Close previous modal if open
      if (currentModal && currentModal !== modal) {
        closeModal(currentModal);
      }
      
      // Open new modal (matching TypeScript ModalManager.open())
      openModal(modal);
      currentModal = modal;
    });
    
    // Close modal handlers
    document.addEventListener('click', (e) => {
      const target = /** @type {HTMLElement} */ (e.target);
      
      // Close button click
      if (target.closest('.popupModal__close')) {
        const modal = target.closest('.popupModal');
        if (modal) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(modal);
          currentModal = null;
        }
        return;
      }
      
      // Mask click to close
      if (target.classList.contains('popupModal__mask')) {
        const modal = target.closest('.popupModal');
        if (modal) {
          closeModal(modal);
          currentModal = null;
        }
        return;
      }
    });
    
    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && currentModal) {
        closeModal(currentModal);
        currentModal = null;
      }
    });
    
    // Open modal function (matching TypeScript ModalManager)
    function openModal(modal) {
      const mask = modal.querySelector('.popupModal__mask');
      const box = modal.querySelector('.popupModal__box');
      if (!mask || !box) return;
      
      // Block scroll
      if (!document.body.classList.contains('has-dialog')) {
        document.body.classList.add('has-dialog');
      }
      
      // Set initial styles (matching GSAP animations from TypeScript)
      modal.style.display = 'flex';
      box.style.pointerEvents = 'all';
      modal.classList.add('popupModal--opened');
      
      // Animate mask
      mask.style.opacity = '1';
      mask.style.visibility = 'inherit';
      
      // Animate box
      box.style.setProperty('--offset', '0px');
      box.style.opacity = '1';
      box.style.visibility = 'inherit';
    }
    
    // Close modal function (matching TypeScript ModalManager)
    function closeModal(modal) {
      const mask = modal.querySelector('.popupModal__mask');
      const box = modal.querySelector('.popupModal__box');
      if (!mask || !box) return;
      
      // Unblock scroll
      if (document.body.classList.contains('has-dialog')) {
        document.body.classList.remove('has-dialog');
      }
      
      // Animate out
      mask.style.opacity = '0';
      mask.style.visibility = 'hidden';
      
      box.style.opacity = '0';
      box.style.visibility = 'hidden';
      box.style.setProperty('--offset', '150px');
      box.style.pointerEvents = 'none';
      
      // Hide modal after animation
      setTimeout(() => {
        modal.style.display = 'none';
        modal.classList.remove('popupModal--opened');
      }, 300);
    }
  }

  // ----- Hover cards: event delegation (works across re-renders) -----
  function initFabricHoverDelegation() {
    const hoverRoot = document.querySelector('[cylindo-fabric-hover-cards]');
    if (!hoverRoot) return;

    // helper: element onHover get title
    const pickTile = (el) => el && el.closest('.fabric-tile.cylindoVariant__option');

    const onOver = (e) => {
      const tile = pickTile(e.target);
      if (!tile || !tabsRoot.contains(tile)) return;

      const val = tile.getAttribute('data-value') || tile.querySelector('input[type="radio"]')?.value;
      if (!val) return;

      tile.classList.add('hovered');

      // remove exisitng hover, apply on matched one
      hoverRoot.querySelectorAll('.cylindoVariant__hover[hovered]')
        .forEach(n => n.removeAttribute('hovered'));

      hoverRoot.querySelectorAll(`.cylindoVariant__hover[data-value="${CSS.escape(val)}"]`)
        .forEach(n => n.setAttribute('hovered', ''));
    };

    const onOut = (e) => {
      const tile = pickTile(e.target);
      if (!tile) return;

      if (tile.contains(e.relatedTarget)) return;

      const val = tile.getAttribute('data-value') || tile.querySelector('input[type="radio"]')?.value;
      tile.classList.remove('hovered');
      if (!val) return;

      hoverRoot.querySelectorAll(`.cylindoVariant__hover[data-value="${CSS.escape(val)}"]`)
        .forEach(n => n.removeAttribute('hovered'));
    };

    tabsRoot.addEventListener('pointerover', onOver);
    tabsRoot.addEventListener('pointerout', onOut);
  }



  // ===== Hide-by-metafield helper =====
  function shouldHideByMeta(valueForTarget, selection) {

  }


  // ----- Tabs availability helpers -----
  function panelHasItems(panel) {
    return !!panel && !!panel.querySelector('.js-panel-item');
  }
  function setDisabled(btn, disabled) {
    if (!btn) return;
    if (disabled) {
      btn.setAttribute('disabled', '');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-disabled');
    } else {
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
      btn.classList.remove('is-disabled');
    }
  }
  function setActiveTab(tabKey) {
    const btn = tabsRoot.querySelector(`.fabric-tabs__btn[data-tab="${tabKey}"]`);
    const panel = tabsRoot.querySelector(`#panel-${tabKey}`);
    if (!btn || !panel) return;
    tabsRoot.querySelectorAll('.fabric-tabs__btn').forEach(b => b.classList.remove('is-active'));
    tabsRoot.querySelectorAll('.fabric-tabs__panel').forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
    panel.classList.add('is-active');
    syncFabricPanelWrapState();
    requestAnimationFrame(() => refreshFabricScrollbars());
  }
  function firstAvailableTab(map) {
    return TAB_KEYS.find((key) => map && map[key]) || null;
  }

  function refreshTabsAvailability() {
    // Unfiltered availability. Active filters must not disable tabs.
    const stored = tabsRoot.__unfilteredHas;
    const has = stored || TAB_KEYS.reduce((acc, key) => {
      acc[key] = panelHasItems(tabsRoot.querySelector(`#panel-${key}`));
      return acc;
    }, {});

    TAB_KEYS.forEach((key) => {
      setDisabled(tabsRoot.querySelector(`.fabric-tabs__btn[data-tab="${key}"]`), !has[key]);
    });

    const activeKey = tabsRoot.querySelector('.fabric-tabs__btn.is-active')?.dataset.tab;
    const filtered = tabsRoot.__filteredHas;
    const filtersOn = hasActiveFabricFilters();

    // When filters empty the active tab, jump to first tab that still has matches.
    // Furniture priority: Instock -> MTO -> Sale. Sale/Full Price: Sale -> Full Price.
    if (filtersOn && filtered) {
      if (!activeKey || !filtered[activeKey]) {
        const next = firstAvailableTab(filtered);
        if (next) setActiveTab(next);
        // If every filtered bucket is empty, leave current tab (empty message stays).
      }
    } else {
      // agar user ne tab khud click kiya hai aur us panel me items hain => respect user
      const keepUser = tabsRoot.__userPicked && activeKey && has[activeKey];

      if (!keepUser) {
        const next = firstAvailableTab(has);
        if (next) setActiveTab(next);
        else {
          // sab empty ho to sabse active hata do
          tabsRoot.querySelectorAll('.fabric-tabs__btn,.fabric-tabs__panel')
            .forEach(n => n.classList.remove('is-active'));
        }
      }
    }

    syncFabricPanelWrapState();
    requestAnimationFrame(() => refreshFabricScrollbars());
  }
  // ===== Initial auto-pick (In-Stock first, else MTO) =====
  function selectFirstInPanel(panelKey) {
    const panel = tabsRoot.querySelector(`#panel-${panelKey}`);
    if (!panel) return false;

    const firstTile = panel.querySelector('.js-panel-item input[type="radio"]');
    if (!firstTile) return false;

    // Activate the tab first
    setActiveTab(panelKey);

    // Select & sync - use a delay to ensure tab is active and visible
    setTimeout(() => {
      // Re-query to ensure we have the latest element
      const currentPanel = tabsRoot.querySelector(`#panel-${panelKey}`);
      const currentInput = currentPanel?.querySelector('.js-panel-item input[type="radio"]');
      
      if (!currentInput) return;
      
      if (!currentInput.checked) {
        // Set checked state
        currentInput.checked = true;
        
        // Update label state
        const label = currentInput.closest('.fabric-tile');
        if (label) {
          label.classList.add('is-selected');
          // Remove is-selected from all other tiles
          document.querySelectorAll('.fabric-tile').forEach(tile => {
            if (tile !== label) tile.classList.remove('is-selected');
          });
        }

        // Fire events in sequence to ensure variant-picker picks it up
        // Use requestAnimationFrame to ensure DOM is ready
        requestAnimationFrame(() => {
          // Fire input event
          currentInput.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          
          // Fire change event after a small delay
          setTimeout(() => {
            currentInput.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            
            // Also try clicking the input directly (more reliable)
            setTimeout(() => {
              // Try clicking the input itself
              if (currentInput && document.contains(currentInput)) {
                currentInput.click();
              }
              
              // Also try clicking the label as fallback
              if (label && document.contains(label)) {
                setTimeout(() => {
                  label.click();
                }, 50);
              }
            }, 50);
          }, 50);
        });
      }
    }, 150);

    return true;
  }

  function autoPickOnLoad() {
    const urlVariant = window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
    if (tabsRoot.__userPicked) return;
    if (urlVariant) return;

    refreshTabsAvailability();

    if (IS_SALE_FULL_PRICE) {
      if (selectFirstInPanel('fullprice')) return;
      selectFirstInPanel('sale');
      return;
    }

    const inStockVariant = findFirstInStockVariant();
    if (inStockVariant) {
      commitVariantSelection(inStockVariant);
      return;
    }

    // Fallback: first fabric in In Stock panel for current size, else MTO
    if (selectFirstInPanel('instock')) return;
    selectFirstInPanel('mto');
  }

  // Auto-click first available variant on page load (for furniture_new template)
  function autoClickFirstAvailableVariant() {
    const urlVariant = window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return;

    // Check if this is furniture_new template
    const productGalleryEl = document.querySelector('[product-gallery]');
    const isFurnitureNew = (productGalleryEl?.dataset?.templateSuffix === 'furniture_new') ||
                           (document.body.classList.contains('template-product') && 
                            window.location.pathname.includes('furniture'));

    if (!isFurnitureNew) return;

    // Wait for variant-picker and tabs to be ready
    const checkReady = (attempts = 0) => {
      const variantPicker = document.querySelector('variant-picker');
      const instockPanel = tabsRoot.querySelector('#panel-instock');
      const mtoPanel = tabsRoot.querySelector('#panel-mto');
      
      const isReady = variantPicker && 
                      variantPicker.variants && 
                      variantPicker.variants.length > 0 &&
                      (instockPanel || mtoPanel); // At least one panel should exist
      
      if (isReady) {
        // Variant picker and panels are ready, now call autoPickOnLoad
        setTimeout(() => {
          // Ensure tabs are refreshed first
          refreshTabsAvailability();
          // Then auto-pick
          autoPickOnLoad();
        }, 150);
      } else if (attempts < 30) {
        // Retry after 100ms (max 3 seconds)
        setTimeout(() => checkReady(attempts + 1), 100);
      }
    };

    // Start checking after a small delay to let DOM settle
    setTimeout(() => {
      checkReady();
    }, 300);
  }



  // > 12 show more button
  // ===== View More (simple + group-aware) =====
  const SHOW_LIMIT = Number(tabsRoot?.dataset.showLimit || 12);

  function applyViewMore(panelEl, limit = SHOW_LIMIT) {
    // reset previous state
    panelEl.querySelectorAll('.fabric-tabs__more').forEach(n => n.remove());
    panelEl.querySelectorAll('.is-hidden').forEach(n => n.classList.remove('is-hidden'));

    const items = [...panelEl.querySelectorAll('.newLabelContainer')];
    if (items.length <= limit) return;

    // hide items beyond limit
    items.forEach((el, i) => { if (i >= limit) el.classList.add('is-hidden'); });

    // hide empty groups (only if groups exist; colors me groups nahi hote)
    [...panelEl.querySelectorAll('.fabric-group__items')].forEach(wrap => {
      const hasVisible = !!wrap.querySelector('.newLabelContainer:not(.is-hidden)');
      const title = wrap.previousElementSibling;
      if (!hasVisible) {
        wrap.classList.add('is-hidden');
        if (title && title.classList.contains('cylindoVariant__groupTitle')) {
          title.classList.add('is-hidden');
        }
      }
    });

    // add "View more" button
    const moreWrap = document.createElement('div');
    moreWrap.className = 'fabric-tabs__more';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fabric-tabs__moreBtn';
    btn.textContent = `View more (${items.length - limit})`;
    btn.addEventListener('click', () => {
      items.forEach(el => el.classList.remove('is-hidden'));
      panelEl.querySelectorAll('.fabric-group__items.is-hidden, .cylindoVariant__groupTitle.is-hidden')
        .forEach(el => el.classList.remove('is-hidden'));
      moreWrap.remove();
      requestAnimationFrame(() => panelEl.__fabricScrollbarUpdate?.());
    });

    moreWrap.appendChild(btn);
    panelEl.appendChild(moreWrap);
  }


  const variants = productData.variants || [];
  const optionsWithValues = productData.options_with_values || [];

  // TARGET option (Fabric > Color > first)
  const TARGET_OPTION_NAME =
    (optionsWithValues.find(o => o.name === 'Fabric')?.name) ||
    (optionsWithValues.find(o => o.name === 'Color')?.name) ||
    (optionsWithValues[0]?.name || 'Fabric');

  const targetOption = optionsWithValues.find(o => o.name === TARGET_OPTION_NAME);
  const nonTargetOptions = optionsWithValues.filter(o => o.name !== TARGET_OPTION_NAME);

  const HAS_FABRIC = optionsWithValues.some(o => o.name === 'Fabric');
  const IS_COLOR_ONLY = !HAS_FABRIC && TARGET_OPTION_NAME === 'Color';

  const variantMetaList = productData.variants_metafields || [];
  const productMetafields = productData.product_metafields || {};
  const INVENTORY_KEY = (tabsRoot.dataset.inventoryKey || '5200 - MVN Warehouse').trim().toLowerCase();

  // variantId -> metafields
  const byIdMeta = new Map();
  variantMetaList.forEach((m, i) => { const v = variants[i]; if (v) byIdMeta.set(v.id, m); });

  // swatch images from option values
  const swatchByValue = new Map();
  if (targetOption && Array.isArray(targetOption.values)) {
    targetOption.values.forEach(v => {
      const name = v?.name || v?.value || v;
      let img = v?.swatch?.image || null;
      // Handle different image formats (string URL or object with src)
      if (img && typeof img === 'object' && img.src) {
        img = img.src;
      } else if (img && typeof img === 'object' && img.url) {
        img = img.url;
      }
      swatchByValue.set(name, img);
    });
  }

  // Optional metaobject fabric images (for fabrics)
  const metaFabricImg = new Map();
  if (fabricData && Array.isArray(fabricData.fabrics)) {
    fabricData.fabrics.forEach(x => {
      if (x?.fabric && x?.image?.url) metaFabricImg.set(x.fabric, x.image.url);
    });
  }

  function parseFabricLabel(value) {
    const lr = String(value).split(' / ');
    const left = (lr[0] || '').trim();
    const color = (lr[1] || '').trim();
    const parts = left.split(',').map(s => s.trim());
    const fabric = parts[0] || '';
    const desc = parts.slice(1).join(', ') || '';
    const groupTitle = desc ? `${fabric}, ${desc}` : fabric;
    return { fabric, desc, color, groupTitle };
  }

  function parseColorLabel(value, filterColor) {
    const raw = String(value || '').trim();
    const family = String(filterColor || '').trim();
    if (!raw) return { title: '', subtitle: family };

    if (raw.includes(' / ')) {
      const [a, b] = raw.split(' / ');
      return { title: (a || '').trim(), subtitle: (b || family).trim() };
    }

    if (family) {
      const escaped = family.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const endsWithFamily = new RegExp(`\\s+${escaped}$`, 'i');
      if (endsWithFamily.test(raw)) {
        const title = raw.replace(endsWithFamily, '').trim();
        return { title: title || raw, subtitle: family };
      }
      if (family.toLowerCase() !== raw.toLowerCase()) {
        return { title: raw, subtitle: family };
      }
      return { title: raw, subtitle: family };
    }

    const parts = raw.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return { title: parts.slice(0, -1).join(' '), subtitle: parts[parts.length - 1] };
    }
    return { title: raw, subtitle: raw };
  }

  function isVariantOnSale(variant) {
    return !!(variant && variant.compare_at_price && variant.compare_at_price > variant.price);
  }

  function isAvailableAnywhere(variantId) {
    const v = variants.find(x => x.id === variantId);
    if (!v) return false;

    const meta = byIdMeta.get(variantId);
    if (meta && meta.custom && meta.custom.availability === false) return false;

    // If inventory_policy is continue (continue selling when out of stock), variant is available
    const inventoryPolicy = v.inventory_policy || v.inventoryPolicy || meta?.inventory_policy;
    if (inventoryPolicy === 'continue' || inventoryPolicy === 'Continue') return true;

    if (!meta) return !!v.available;

    const inv = meta.inventory || {};
    if (inv.available_at_locations != null) {
      const n = Number(inv.available_at_locations);
      if (!Number.isNaN(n) && n > 0) return true;
    }
    const locs = inv.available_counts_per_location;
    const getQty = r => Number(typeof r?.available === 'number' ? r.available : (r?.available || 0)) || 0;

    if (Array.isArray(locs)) {
      if (locs.length && Array.isArray(locs[0])) return locs.reduce((a, e) => a + getQty(e?.[1]), 0) > 0;
      return locs.reduce((a, r) => a + getQty(r), 0) > 0;
    }
    if (locs && typeof locs === 'object') return Object.values(locs).reduce((a, r) => a + getQty(r), 0) > 0;

    return !!v.available;
  }

  function isInStockAtLocation(variantId) {
    const meta = byIdMeta.get(variantId);
    const locs = meta?.inventory?.available_counts_per_location;

    const matchOne = (rec) => {
      const nm = (rec?.name || rec?.location?.name || '').trim().toLowerCase();
      const qty = Number(typeof rec?.available === 'number' ? rec.available : (rec?.available || 0)) || 0;
      return nm === INVENTORY_KEY && qty > 0;
    };

    if (locs) {
      if (Array.isArray(locs)) {
        if (locs.length && Array.isArray(locs[0])) {
          if (locs.some(e => matchOne(e?.[1]))) return true;
        } else {
          if (locs.some(matchOne)) return true;
        }
      } else if (locs && typeof locs === 'object') {
        if (Object.values(locs).some(matchOne)) return true;
      }
    }

    // Positive MVN inventory always belongs in In Stock. The inventory policy
    // only keeps zero-stock variants purchasable; those remain Made To Order.
    return false;
  }

  function findFirstInStockVariant() {
    for (const v of variants) {
      if (isAvailableAnywhere(v.id) && isInStockAtLocation(v.id)) {
        return v;
      }
    }
    return null;
  }

  function applyVariantOptions(variant, { silent = false } = {}) {
    if (!variant || !Array.isArray(variant.options)) return;

    optionsWithValues.forEach(o => {
      const pos = (o.position || 1) - 1;
      const desired = variant.options[pos];
      if (!desired) return;

      const nm = optionInputNameFor(o.name);

      const radio = document.querySelector(
        `input[name="${CSS.escape(nm)}"][value="${CSS.escape(desired)}"]`
      );
      if (radio && radio instanceof HTMLInputElement) {
        if (!radio.checked) radio.checked = true;
        if (!silent) {
          radio.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          radio.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        }
        return;
      }

      const select = document.querySelector(
        `select[name="${CSS.escape(nm)}"], select[name="options[${CSS.escape(o.name)}]"], select[name="options[${CSS.escape(o.name.toLowerCase())}]"]`
      );
      if (select && select instanceof HTMLSelectElement) {
        if (select.value !== desired) select.value = desired;
        if (!silent) {
          select.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          select.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        }
      }
    });
  }

  function applyNonTargetOptionsSilently(variant) {
    nonTargetOptions.forEach(o => {
      const pos = (o.position || 1) - 1;
      const desired = variant.options[pos];
      if (!desired) return;

      const nm = optionInputNameFor(o.name);
      const radio = document.querySelector(
        `input[name="${CSS.escape(nm)}"][value="${CSS.escape(desired)}"]`
      );
      if (radio && radio instanceof HTMLInputElement) {
        radio.checked = true;
        const selectHost = radio.closest('[select-product-option]');
        if (selectHost?.selectProductOptionHandler?.showCurrentValue) {
          selectHost.selectProductOptionHandler.showCurrentValue();
        }
        return;
      }

      const select = document.querySelector(
        `select[name="${CSS.escape(nm)}"], select[name="options[${CSS.escape(o.name)}]"], select[name="options[${CSS.escape(o.name.toLowerCase())}]"]`
      );
      if (select && select instanceof HTMLSelectElement) {
        select.value = desired;
      }
    });
  }

  function dispatchOptionChange(input) {
    if (!(input instanceof HTMLInputElement)) return;
    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
  }

  function commitVariantSelection(variant) {
    if (!variant || !Array.isArray(variant.options)) return false;

    window.__INITIAL_IN_STOCK_VARIANT_ID = variant.id;
    applyNonTargetOptionsSilently(variant);
    renderAll();
    setActiveTab('instock');
    tabsRoot.__userPicked = true;

    const targetPos = (targetOption?.position || 1) - 1;
    const targetValue = variant.options[targetPos];
    const inputName = optionInputNameFor(TARGET_OPTION_NAME);

    requestAnimationFrame(() => {
      setTimeout(() => {
        const instockPanel = tabsRoot.querySelector('#panel-instock');
        const targetInput = instockPanel?.querySelector(
          `input[name="${CSS.escape(inputName)}"][value="${CSS.escape(targetValue)}"]`
        ) || document.querySelector(
          `input[name="${CSS.escape(inputName)}"][value="${CSS.escape(targetValue)}"]`
        );

        if (targetInput && targetInput instanceof HTMLInputElement) {
          targetInput.checked = true;
          const label = targetInput.closest('.fabric-tile');
          if (label) {
            label.classList.add('is-selected');
            document.querySelectorAll('.fabric-tile').forEach(tile => {
              if (tile !== label) tile.classList.remove('is-selected');
            });
          }
          dispatchOptionChange(targetInput);
          tabsRoot.__autoPickCommitted = true;
          return;
        }

        if (selectFirstInPanel('instock')) {
          tabsRoot.__autoPickCommitted = true;
        }
      }, 150);
    });

    return true;
  }

  window.__findFirstInStockVariant = findFirstInStockVariant;
  window.__commitVariantSelection = commitVariantSelection;

  function getLeadTimeForVariant(v) {
    const meta = byIdMeta.get(v.id);
    return (meta?.new_my_fields?.lead_time)
      || (productMetafields?.new_my_fields?.lead_time)
      || '';
  }

  function getCurrentSelection() {
    // If user landed on PDP with ?variant= (from SLP/header search),
    // prefer that variant's options as the source of truth on first render.
    const urlVariantRaw =
      window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
    const urlVariantId = urlVariantRaw ? Number(String(urlVariantRaw).trim()) : NaN;
    const urlVariantObj = Number.isFinite(urlVariantId)
      ? variants.find(v => Number(v.id) === urlVariantId)
      : null;

    const sel = {};
    optionsWithValues.forEach(o => {
      const n = o.name;
      // supports "Size" and "options[Size]" (and lowercase)
      const q = [
        `input[name="${CSS.escape(n)}"]:checked`,
        `input[name="options[${CSS.escape(n)}]"]:checked`,
        `input[name="${CSS.escape(n.toLowerCase())}"]:checked`,
        `input[name="options[${CSS.escape(n.toLowerCase())}]"]:checked`
      ].join(',');

      const inp = document.querySelector(q);
      if (inp) {
        sel[n] = inp.value;
      } else {
        const pos = (o.position || 1) - 1;
        const initialInStockId = window.__INITIAL_IN_STOCK_VARIANT_ID;
        const initialInStockVariant = Number.isFinite(initialInStockId)
          ? variants.find(v => Number(v.id) === initialInStockId)
          : null;

        sel[n] = urlVariantObj?.options?.[pos]
          || initialInStockVariant?.options?.[pos]
          || productData.product?.selected_or_first_available_variant?.options?.[pos]
          || productData.product?.variants?.[0]?.options?.[pos]
          || null;
      }
    });
    return sel;
  }

  function variantMatches(selection, valueForTarget) {
    const nameToPos = new Map(optionsWithValues.map(o => [o.name, (o.position || 1) - 1]));
    return variants.filter(v => {
      for (const o of nonTargetOptions) {
        const pos = nameToPos.get(o.name);
        if (pos == null) continue;
        const need = selection[o.name];
        if (need && v.options[pos] !== need) return false;
      }
      if (targetOption) {
        const fpos = nameToPos.get(TARGET_OPTION_NAME);
        if (fpos == null) return false;
        if (v.options[fpos] !== valueForTarget) return false;
      }
      return true;
    });
  }

  // ===== Groups (instock / mto / sale) or (sale / fullprice) =====
  function computeGroups(selection) {
    if (IS_SALE_FULL_PRICE) {
      const out = { sale: [], fullprice: [] };
      if (!targetOption || !Array.isArray(targetOption.values)) return out;

      const seen = new Set();
      targetOption.values.forEach(val => {
        const value = val?.name || val?.value || val;
        if (!value || seen.has(value)) return;

        const matched = variantMatches(selection, value);
        if (!matched.length) return;

        const available = matched.filter(v => isAvailableAnywhere(v.id));
        if (!available.length) return;

        const saleVariant = available.find(isVariantOnSale);
        const fullVariant = available.find(v => !isVariantOnSale(v));

        if (saleVariant) {
          out.sale.push({
            value,
            leadTime: getLeadTimeForVariant(saleVariant),
            instockHere: true,
            variant: saleVariant,
          });
        }
        const allColorsVariant = fullVariant || saleVariant;
        if (allColorsVariant) {
          out.fullprice.push({
            value,
            leadTime: getLeadTimeForVariant(allColorsVariant),
            instockHere: true,
            variant: allColorsVariant,
          });
        }

        seen.add(value);
      });

      return out;
    }

    const out = { instock: [], mto: [], sale: [] };
    if (!targetOption || !Array.isArray(targetOption.values)) return out;

    const seen = new Set();
    targetOption.values.forEach(val => {
      const value = val?.name || val?.value || val;
      if (!value || seen.has(value)) return;

      const matched = variantMatches(selection, value);
      if (!matched.length) return;

      const available = matched.filter(v => isAvailableAnywhere(v.id));
      if (!available.length) return;

      const chosen = available[0];
      const leadTime = getLeadTimeForVariant(chosen);
      const anySale = available.some(isVariantOnSale);
      const anyInStockHere = available.some(v => isInStockAtLocation(v.id));

      const entry = { value, leadTime, instockHere: anyInStockHere, variant: chosen };
      if (anySale) out.sale.push(entry);
      if (anyInStockHere) out.instock.push({ value, leadTime, variant: chosen });
      else out.mto.push({ value, leadTime, variant: chosen });

      seen.add(value);
    });

    return out;
  }

  // ===== Fabric filter drawer helpers =====
  function normalizeFilterColor(raw) {
    if (raw == null || raw === '') return '';
    if (Array.isArray(raw)) {
      const first = raw.find((x) => x != null && String(x).trim() !== '');
      return first != null ? String(first).trim() : '';
    }
    if (typeof raw === 'object') {
      if (Array.isArray(raw.value)) return normalizeFilterColor(raw.value);
      if (raw.value != null) return normalizeFilterColor(raw.value);
    }
    return String(raw).trim();
  }

  function normalizeFilterMaterial(raw) {
    if (raw == null || raw === '') return '';
    if (typeof raw === 'object' && raw.value != null) return String(raw.value).trim();
    return String(raw).trim();
  }

  function getVariantFilterMeta(variant) {
    if (!variant || !variant.id) return { filterColor: '', material: '' };
    const meta = byIdMeta.get(variant.id) || {};
    const filterColor = normalizeFilterColor(
      meta?.new_my_fields?.filter_color?.value ?? meta?.new_my_fields?.filter_color
    );
    const material = normalizeFilterMaterial(
      meta?.my_fields?.material?.value ?? meta?.my_fields?.material
    );
    return { filterColor, material };
  }

  function getAppliedFabricFilters() {
    if (window.FabricFilterDrawer && typeof window.FabricFilterDrawer.getApplied === 'function') {
      return window.FabricFilterDrawer.getApplied();
    }
    return { colors: [], materials: [] };
  }

  function hasActiveFabricFilters() {
    const f = getAppliedFabricFilters();
    return (f.colors && f.colors.length > 0) || (f.materials && f.materials.length > 0);
  }

  function applyFabricFilters(tiles) {
    const { colors, materials } = getAppliedFabricFilters();
    const colorSet = (colors || []).map((c) => String(c).trim().toLowerCase()).filter(Boolean);
    const materialSet = (materials || []).map((m) => String(m).trim().toLowerCase()).filter(Boolean);
    if (!colorSet.length && !materialSet.length) return tiles;

    return (tiles || []).filter((t) => {
      const colorOk = !colorSet.length || colorSet.includes(String(t.filterColor || '').trim().toLowerCase());
      const materialOk = !materialSet.length || materialSet.includes(String(t.material || '').trim().toLowerCase());
      return colorOk && materialOk;
    });
  }

  function showFabricFilterEmpty(panelEl) {
    if (!panelEl) return;
    panelEl.innerHTML = '';
    const msg = document.createElement('p');
    msg.className = 'fabric-tabs__empty-filter';
    msg.textContent = 'No matching options in this category';
    panelEl.appendChild(msg);
  }

  function renderPanelWithFilters(panelEl, filteredTiles, unfilteredCount, selection, renderFn) {
    if (!panelEl) return;
    if (!filteredTiles.length) {
      if (unfilteredCount > 0 && hasActiveFabricFilters()) {
        showFabricFilterEmpty(panelEl);
      } else {
        panelEl.innerHTML = '';
      }
      return;
    }
    renderFn(panelEl, filteredTiles, selection);
  }

  function toTileObjects(arr) {
    return arr.map((obj) => {
      const { value, leadTime, instockHere = false, variant } = obj || {};
      const h = value.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      const p = parseFabricLabel(value);
      
      // Get custom.swatch metafield from variant
      let customSwatch = null;
      if (variant && variant.id) {
        const variantMeta = byIdMeta.get(variant.id);
        if (variantMeta && variantMeta.custom && variantMeta.custom.swatch) {
          customSwatch = variantMeta.custom.swatch.value || variantMeta.custom.swatch;
          // Handle if it's an object with url property
          if (customSwatch && typeof customSwatch === 'object' && customSwatch.url) {
            customSwatch = customSwatch.url;
          }
        }
      }

      const filterMeta = getVariantFilterMeta(variant);
      
      return {
        value,
        value_handle: h,
        fabric: p.fabric,
        desc: p.desc,
        color: p.color,
        groupTitle: p.groupTitle,
        leadTime,
        swatch_image: swatchByValue.get(value) || null,
        meta_img: metaFabricImg.get(value) || null,
        custom_swatch: customSwatch,
        instockHere: !!instockHere,
        filterColor: filterMeta.filterColor,
        material: filterMeta.material,
      };
    });
  }

  // ===== Helpers for Color grid IDs / names =====
  function getProductFormId() {
    const form = document.querySelector('form[id^="product-form-"]');
    return form ? form.id : null;
  }
  function optionInputNameFor(optName) {
    const exact = document.querySelector(`input[name="options[${CSS.escape(optName)}]"]`);
    if (exact) return `options[${optName}]`;
    const lo = optName.toLowerCase();
    const lower = document.querySelector(`input[name="options[${CSS.escape(lo)}]"]`);
    if (lower) return `options[${lo}]`;
    return optName;
  }
  const handleize = (s) => String(s).toLowerCase()
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const fallbackSwatchURL = (val) => {
    const h = handleize(val);
    const host = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : location.host;
    return `//${host}/cdn/shop/files/${h}_84x84.png`;
  };

  // ===== THEME-STYLE COLOR GRID inside each TAB panel =====
  function renderColorPanel(panelEl, tiles, selection, blockTitle) {
    panelEl.innerHTML = '';
    if (!tiles.length) return;

    const compact = IS_SALE_FULL_PRICE;
    const leadSet = new Set(tiles.map(t => t.leadTime).filter(Boolean));
    if (!compact) {
      const header = document.createElement('div');
      header.className = 'product-options__header';
      header.innerHTML = `
      <hr class="product-options__option-divider">
      ${leadSet.size === 1 ? `<p class="product-options__headerLead">Lead Time: ${[...leadSet][0]}</p>` : ''}`;
      panelEl.appendChild(header);
    }

    const byLead = new Map();
    tiles.forEach(t => {
      const lt = compact ? '' : (t.leadTime || '');
      if (!byLead.has(lt)) byLead.set(lt, []);
      byLead.get(lt).push(t);
    });

    const formId = (function () {
      const f = document.querySelector('form[id^="product-form-"]');
      return f ? f.id : null;
    })();
    const inputNm = (function (optName) {
      if (document.querySelector(`input[name="options[${CSS.escape(optName)}]"]`)) return `options[${optName}]`;
      const lo = optName.toLowerCase();
      if (document.querySelector(`input[name="options[${CSS.escape(lo)}]"]`)) return `options[${lo}]`;
      return optName;
    })(TARGET_OPTION_NAME);

    const current = selection[TARGET_OPTION_NAME];

    const handleize = (s) => String(s).toLowerCase()
      .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const fallbackSwatchURL = (val) => {
      const h = handleize(val);
      const host = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : location.host;
      return `//${host}/cdn/shop/files/${h}_84x84.png`;
    };

    byLead.forEach((items, lt) => {
      if (!compact && leadSet.size > 1 && lt) {
        const sub = document.createElement('div');
        sub.className = 'product-options__header';
        sub.innerHTML = `<p class="product-options__headerLead">Lead time: ${lt}</p>`;
        panelEl.appendChild(sub);
      }

      const grid = document.createElement('div');
      grid.className = compact
        ? 'product-options__option-grid color-grid sale-price-tabs__grid'
        : 'product-options__option-grid color-grid';
      panelEl.appendChild(grid);

      items.forEach(t => {
        // if (shouldHideByMeta(t.value, selection)) return; 
        const id = `option-${TARGET_OPTION_NAME.toLowerCase()}-${t.value_handle}-${Math.random().toString(36).slice(2, 7)}`;

        const wrap = document.createElement('div');
        wrap.className = 'product-options__option-value js-panel-item'; // ⬅️ mark item

        const input = document.createElement('input');
        input.type = 'radio';
        input.className = 'swatch-input__input';
        input.id = id;
        input.name = inputNm;
        input.value = t.value;
        if (formId) input.setAttribute('form', formId);
        if (current === t.value) input.checked = true;
        // input.addEventListener('change', ()=>{
        //   input.dispatchEvent(new Event('input',  { bubbles:true }));
        //   input.dispatchEvent(new Event('change', { bubbles:true }));
        // });

        const label = document.createElement('label');
        label.className = 'swatch-input__label swatch-input__label--square';
        label.setAttribute('for', id);
        label.setAttribute('title', t.value);

        const sw = document.createElement('span');
        sw.className = 'swatch swatch--square';
        // Priority: swatch_image > meta_img > custom.swatch metafield > fallback file URL
        let imgUrl = t.swatch_image || t.meta_img || t.custom_swatch || fallbackSwatchURL(t.value);
        
        // Handle different URL formats
        let finalUrl = '';
        if (imgUrl) {
          // If it's already a url() format, extract the URL
          if (imgUrl.startsWith('url(')) {
            finalUrl = imgUrl.match(/url\(['"]?([^'"]+)['"]?\)/)?.[1] || imgUrl.replace(/^url\(['"]?|['"]?\)$/g, '');
          } else {
            finalUrl = imgUrl;
          }
        }
        
        // Set both CSS custom property and direct background-image for compatibility
        const styleParts = ['--swatch--color: ;'];
        if (finalUrl) {
          styleParts.push(`--swatch--background: url('${finalUrl}');`);
          styleParts.push(`background-image: url('${finalUrl}');`);
          styleParts.push('background-size: cover;');
          styleParts.push('background-position: center;');
          styleParts.push('background-repeat: no-repeat;');
        }
        
        sw.setAttribute('style', styleParts.join(' '));

        const text = document.createElement('span');
        if (compact) {
          const parsed = parseColorLabel(t.value, t.filterColor);
          text.className = 'sale-price-tabs__caption';
          const title = document.createElement('span');
          title.className = 'sale-price-tabs__caption-title';
          title.textContent = parsed.title;
          text.appendChild(title);
        } else {
          text.textContent = t.value;
        }

        label.appendChild(sw);
        label.appendChild(text);
        wrap.appendChild(input);
        wrap.appendChild(label);
        grid.appendChild(wrap);
      });
    });

    applyViewMore(panelEl);
    attachIOSVariantTapFix(panelEl);
  }



  // ===== FABRIC renderers (unchanged) =====
  function renderInstockPanel(panelEl, tiles, selection) {
    panelEl.innerHTML = '';
    if (!tiles.length) return;

    const groups = new Map(); // leadTime => items[]
    tiles.forEach(t => {
      const key = t.leadTime || '—';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(t);
    });

    const currentVal = selection && selection[TARGET_OPTION_NAME];

    groups.forEach((items, lt) => {
      if (lt && lt !== '—') {
        const hdr = document.createElement('div');
        hdr.className = 'product-options__header';
        hdr.innerHTML = `<p class="product-options__headerLead" ltcustom stockVariant>Lead time: ${lt}</p>`;
        panelEl.appendChild(hdr);
      }

      const wrap = document.createElement('div');
      wrap.className = 'fabric-tiles';
      panelEl.appendChild(wrap);

      items.forEach(t => {
        // if (shouldHideByMeta(t.value, selection)) return;
        const item = document.createElement('div');
        item.className = 'newLabelContainer';
        const label = document.createElement('label');
        label.className = 'fabric-tile cylindoVariant__option js-panel-item'; // ⬅️ mark item
        label.tabIndex = 0;
        label.setAttribute('data-value', t.value);
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = TARGET_OPTION_NAME;
        input.id = `Fabric_${t.value_handle}`;
        input.value = t.value;
        input.classList.add('visually-hidden');
        label.setAttribute('for', input.id);
        if (currentVal === t.value) {
          input.checked = true;
          label.classList.add('is-selected');
        }
        input.addEventListener('change', () => {
          label.classList.add('is-selected');
          document.querySelectorAll('.fabric-tile').forEach(x => { if (x !== label) x.classList.remove('is-selected'); });
          // input.dispatchEvent(new Event('input',{bubbles:true}));
          // input.dispatchEvent(new Event('change',{bubbles:true}));
        });

        const sw = document.createElement('div');
        sw.className = 'cylindoVariant__optionDisplay';
        const imgSrc = t.swatch_image || t.meta_img || null;
        if (imgSrc) {
          const img = document.createElement('img');
          img.src = imgSrc; img.alt = t.value;
          sw.appendChild(img);
        } else {
          sw.textContent = t.fabric || '—';
        }

        const pf = document.createElement('p');
        pf.className = 'cylindoVariant__option-fabric';
        pf.textContent = t.fabric || '';

        const pc = document.createElement('p');
        pc.className = 'cylindoVariant__option-color';
        pc.textContent = t.color || '';

        const pd = document.createElement('p');
        pd.className = 'cylindoVariant__option-desc';
        pd.textContent = t.desc || '';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('toggle-modal', 'modal-' + t.value);
        btn.textContent = 'View Details';
        // BRUTE FORCE: any tap on tile selects radio (except the modal button)
        label.addEventListener('click', (e) => {
          if (e.target.closest('button,[toggle-modal]')) return; // don't change selection when opening modal
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        label.appendChild(input);
        label.appendChild(sw);
        label.appendChild(pf);
        label.appendChild(pc);
        label.appendChild(pd);
        item.appendChild(label);  // label first
        item.appendChild(btn);    // button as sibling of label
        wrap.appendChild(item);
      });
    });

    applyViewMore(panelEl);
    attachIOSVariantTapFix(panelEl);
  }


  function renderMtoLike(panelEl, tiles, selection) {
    renderInstockPanel(panelEl, tiles, selection);
  }
  function renderSalePanel(panelEl, tiles, selection) {
    panelEl.innerHTML = '';
    if (!tiles.length) return;

    // split: in-stock first, then MTO
    const instockFirst = tiles.filter(t => t.instockHere);
    const mtoLater = tiles.filter(t => !t.instockHere);

    // local helper: same layout as renderInstockPanel (by lead time)
    const renderBlock = (list) => {
      if (!list.length) return;

      const groups = new Map(); // leadTime => items[]
      list.forEach(t => {
        const key = t.leadTime || '—';
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(t);
      });

      const currentVal = selection && selection[TARGET_OPTION_NAME];

      groups.forEach((items, lt) => {
        if (lt && lt !== '—') {
          const hdr = document.createElement('div');
          hdr.className = 'product-options__header';
          hdr.innerHTML = `<p class="product-options__headerLead" ltcustom stockVariant>Lead time: ${lt}</p>`;
          panelEl.appendChild(hdr);
        }

        const wrap = document.createElement('div');
        wrap.className = 'fabric-tiles';
        panelEl.appendChild(wrap);

        items.forEach(t => {
          // if (shouldHideByMeta(t.value, selection)) return;
          const item = document.createElement('div');
          item.className = 'newLabelContainer';
          const label = document.createElement('label');
          label.className = 'fabric-tile cylindoVariant__option js-panel-item';
          label.tabIndex = 0;
          label.setAttribute('data-value', t.value);

          const input = document.createElement('input');
          input.type = 'radio';
          input.name = TARGET_OPTION_NAME;
          input.id = `Fabric_${t.value_handle}`;
          input.value = t.value;
          input.hidden = true;

          if (currentVal === t.value) {
            input.checked = true;
            label.classList.add('is-selected');
          }

          input.addEventListener('change', () => {
            label.classList.add('is-selected');
            document.querySelectorAll('.fabric-tile').forEach(x => {
              if (x !== label) x.classList.remove('is-selected');
            });
          });

          const sw = document.createElement('div');
          sw.className = 'cylindoVariant__optionDisplay';
          const imgSrc = t.swatch_image || t.meta_img || null;
          if (imgSrc) {
            const img = document.createElement('img');
            img.src = imgSrc; img.alt = t.value;
            sw.appendChild(img);
          } else {
            sw.textContent = t.fabric || '—';
          }

          const pf = document.createElement('p');
          pf.className = 'cylindoVariant__option-fabric';
          pf.textContent = t.fabric || '';

          const pc = document.createElement('p');
          pc.className = 'cylindoVariant__option-color';
          pc.textContent = t.color || '';

          const pd = document.createElement('p');
          pd.className = 'cylindoVariant__option-desc';
          pd.textContent = t.desc || '';

          const btn = document.createElement('button');
          btn.setAttribute('toggle-modal', 'modal-' + t.value);
          btn.textContent = 'View Details';

          label.appendChild(input);
          label.appendChild(sw);
          label.appendChild(pf);
          label.appendChild(pc);
          label.appendChild(pd);
          item.appendChild(label);  // label first
          item.appendChild(btn);    // button as sibling of label
          wrap.appendChild(item);
        });
      });
    };

    // render in the wanted order:
    renderBlock(instockFirst);
    renderBlock(mtoLater);

    applyViewMore(panelEl);
  }
  function attachIOSVariantTapFix(root) {
    const tiles = root.querySelectorAll('.fabric-tile.cylindoVariant__option');
    tiles.forEach((label) => {
      if (label.__iosBound) return;
      label.__iosBound = true;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      const handler = (e) => {
        // modal/open buttons ko ignore
        // if (e.target.closest('button,[toggle-modal]')) return;

        // kill native path (iOS label quirks) + stop other handlers
        // if (e) {
        //   if (e.cancelable) e.preventDefault();
        //   e.stopPropagation();
        //   if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        // }

        // ensure selection + events
        if (!input.checked) {
          // focus helps iOS sometimes
          try { input.focus({ preventScroll: true }); } catch { }
          input.checked = true;
        }
        // fire twice (some themes swallow first)
        const fireOnce = () => {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        fireOnce();
        requestAnimationFrame(fireOnce);

      };

      // bind on multiple phases to be extra safe on iOS
      label.addEventListener('pointerup', handler, { passive: false });
      label.addEventListener('touchend', handler, { passive: false });
      label.addEventListener('click', handler, { passive: false });
    });
  }


  // ===== Render All =====
  function renderAll() {
    const selection = getCurrentSelection();
    const grouped = computeGroups(selection);

    if (IS_SALE_FULL_PRICE) {
      const saleTile = toTileObjects(grouped.sale || []);
      const fullTile = toTileObjects(grouped.fullprice || []);

      tabsRoot.__unfilteredHas = {
        sale: saleTile.length > 0,
        fullprice: fullTile.length > 0,
      };

      const filteredSale = applyFabricFilters(saleTile);
      const filteredFull = applyFabricFilters(fullTile);

      tabsRoot.__filteredHas = {
        sale: filteredSale.length > 0,
        fullprice: filteredFull.length > 0,
      };

      renderPanelWithFilters($('#panel-sale', tabsRoot), filteredSale, saleTile.length, selection, (el, tiles, sel) => {
        renderColorPanel(el, tiles, sel, 'Sale');
      });
      renderPanelWithFilters($('#panel-fullprice', tabsRoot), filteredFull, fullTile.length, selection, (el, tiles, sel) => {
        renderColorPanel(el, tiles, sel, 'All Colors');
      });
    } else {
      const instockTile = toTileObjects(grouped.instock);
      const mtoTile = toTileObjects(grouped.mto);
      const saleTile = toTileObjects(grouped.sale);

      // Store unfiltered availability so tabs stay enabled when filters empty a panel
      tabsRoot.__unfilteredHas = {
        instock: instockTile.length > 0,
        mto: mtoTile.length > 0,
        sale: saleTile.length > 0,
      };

      const filteredInstock = applyFabricFilters(instockTile);
      const filteredMto = applyFabricFilters(mtoTile);
      const filteredSale = applyFabricFilters(saleTile);

      tabsRoot.__filteredHas = {
        instock: filteredInstock.length > 0,
        mto: filteredMto.length > 0,
        sale: filteredSale.length > 0,
      };

      const instockPanel = $('#panel-instock', tabsRoot);
      const mtoPanel = $('#panel-mto', tabsRoot);
      const salePanel = $('#panel-sale', tabsRoot);

      if (IS_COLOR_ONLY) {
        // Tabs visible + theme swatch grid inside panels
        renderPanelWithFilters(instockPanel, filteredInstock, instockTile.length, selection, (el, tiles, sel) => {
          renderColorPanel(el, tiles, sel, 'In Stock');
        });
        renderPanelWithFilters(mtoPanel, filteredMto, mtoTile.length, selection, (el, tiles, sel) => {
          renderColorPanel(el, tiles, sel, 'Made To Order');
        });
        renderPanelWithFilters(salePanel, filteredSale, saleTile.length, selection, (el, tiles, sel) => {
          renderColorPanel(el, tiles, sel, 'Sale');
        });
      } else {
        // Fabric (or other target) = your existing tiles UI
        renderPanelWithFilters(instockPanel, filteredInstock, instockTile.length, selection, renderInstockPanel);
        renderPanelWithFilters(mtoPanel, filteredMto, mtoTile.length, selection, renderMtoLike);
        renderPanelWithFilters(salePanel, filteredSale, saleTile.length, selection, renderSalePanel);
      }
    }
    attachIOSVariantTapFix(tabsRoot);

    // If the current variant/selection belongs to a specific tab (instock/mto/sale),
    // ensure that tab is active. This prevents "red sofa" (variant URL) landing on
    // the wrong tab due to default priority (instock first) and avoids unchecking
    // the currently selected value.
    (function syncActiveTabToSelection() {
      const currentVal = selection[TARGET_OPTION_NAME];
      if (!currentVal) return;

      const inputName = optionInputNameFor(TARGET_OPTION_NAME);
      const selector = `input[name="${CSS.escape(inputName)}"][value="${CSS.escape(currentVal)}"]`;

      const keys = TAB_KEYS;
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const panel = tabsRoot.querySelector(`#panel-${key}`);
        if (!panel) continue;
        if (panel.querySelector(selector)) {
          // Treat as user-picked so refreshTabsAvailability respects it.
          tabsRoot.__userPicked = true;
          setActiveTab(key);
          return;
        }
      }
    })();

    // safety: if current selection is not in active tab, uncheck it
    const activePanel = $('.fabric-tabs__panel.is-active', tabsRoot);
    const currentVal = selection[TARGET_OPTION_NAME];
    if (activePanel && currentVal) {
      const inActive = activePanel.querySelector(
        `input[name="${CSS.escape(optionInputNameFor(TARGET_OPTION_NAME))}"][value="${CSS.escape(currentVal)}"]`
      );
      if (!inActive) {
        const checked = tabsRoot.querySelector(
          `input[name="${CSS.escape(optionInputNameFor(TARGET_OPTION_NAME))}"][value="${CSS.escape(currentVal)}"]`
        );
        if (checked) checked.checked = false;
      }
    }
    refreshTabsAvailability();
    requestAnimationFrame(() => refreshFabricScrollbars());

    // After panels and tiles are in sync with current selection, update hover card prices
    updateHoverCardPrices();
  }

  // Tabs switching (works for both cases)
  $$('.fabric-tabs__btn', tabsRoot).forEach(btn => {
    if (!btn.__bound) {
      btn.addEventListener('click', () => {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-disabled')) return;
        const previousTab = tabsRoot.querySelector('.fabric-tabs__btn.is-active')?.dataset.tab;
        const tab = btn.dataset.tab;
        if (!tab) return;

        tabsRoot.__userPicked = true;
        setActiveTab(tab);

        // Switching inventory buckets must also switch the selected variant;
        // otherwise price, URL, gallery, and lead time stay on the old tab's variant.
        if (previousTab !== tab) {
          const panel = tabsRoot.querySelector(`#panel-${tab}`);
          const firstInput = panel?.querySelector('.js-panel-item input[type="radio"]');
          if (firstInput instanceof HTMLInputElement) {
            if (!firstInput.checked) {
              firstInput.checked = true;
              const selectedTile = firstInput.closest('.fabric-tile');
              if (selectedTile) {
                selectedTile.classList.add('is-selected');
                document.querySelectorAll('.fabric-tile').forEach((tile) => {
                  if (tile !== selectedTile) tile.classList.remove('is-selected');
                });
              }
            }
            dispatchOptionChange(firstInput);
          }
        }
      });
      btn.__bound = true;
    }
  });



  // Re-render on any non-target option change (Size/Orientation etc.)
  function bindNonTargetChange() {
    nonTargetOptions.forEach(o => {
      const n = o.name;
      const sel = [
        `input[name="${CSS.escape(n)}"]`,
        `input[name="options[${CSS.escape(n)}]"]`,
        `input[name="${CSS.escape(n.toLowerCase())}"]`,
        `input[name="options[${CSS.escape(n.toLowerCase())}]"]`
      ].join(',');

      $$(sel).forEach(inp => {
        if (!inp.__fabricTabsBound) {
          inp.addEventListener('change', renderAll);
          inp.addEventListener('input', renderAll);
          inp.__fabricTabsBound = true;
        }
      });
    });

    // delegated fallback if theme re-renders
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      const nm = (t.name || '').toLowerCase();
      const hit = nonTargetOptions.some(o => {
        const on = o.name.toLowerCase();
        return nm === on || nm === `options[${on}]`;
      });
      if (hit) renderAll();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindNonTargetChange();
    renderAll();
    // Render hover cards first, then initialize hover delegation and modal handling
    renderFabricHoverCards();
    updateHoverCardPrices();
    initFabricHoverDelegation();
    initModalHandling();
    setTimeout(autoPickOnLoad, 0);
    // Also call auto-click for furniture_new template
    autoClickFirstAvailableVariant();

    // If user landed with ?variant= from SLP/header search, ensure the theme variant picker
    // receives option change events so price/add-to-cart state initializes without manual clicks.
    // This is intentionally scoped to first load and does NOT run after user interaction.
    setTimeout(() => {
      if (tabsRoot.__urlVariantApplied) return;
      const urlVariantRaw =
        window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
      const urlVariantId = urlVariantRaw ? Number(String(urlVariantRaw).trim()) : NaN;
      if (!Number.isFinite(urlVariantId)) return;

      const v = variants.find(x => Number(x.id) === urlVariantId);
      if (!v || !Array.isArray(v.options)) return;

      tabsRoot.__urlVariantApplied = true;

      applyVariantOptions(v);

      // Re-render panels + sync active tab after variant picker has processed events
      requestAnimationFrame(() => {
        renderAll();
      });
    }, 0);
  });

  // Fabric filter drawer → re-render panels with applied filters (persists across tabs)
  document.addEventListener('fabric:filters-changed', () => {
    renderAll();
  });

  // Keep Fabric tab buckets aligned with external variant updates
  // (e.g. dropdown-driven selection and variant-picker normalization).
  document.addEventListener('variant:changed', () => {
    renderAll();
  });
  document.addEventListener('flu:product:variant-change', () => {
    renderAll();
  });


})();
